// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { OnInit, OnDestroy } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { PolicyEffectType, } from '@app/core';
import { selectResourceActionsNeedLoading, LoadingPolicyStatementServicesAction, LoadingPolicyStatementResourceActionsAction, RemoveStatementAction, SelectEffectAction, SelectServiceAction, SelectResourceAction, SelectActionActions, selectStatementServices, selectStatementResources, selectStatementActions, selectLoadableResourceActions, } from '../../state';
var PolicyStatementCardComponent = /** @class */ (function () {
    function PolicyStatementCardComponent(store) {
        var _this = this;
        this.store = store;
        this.statement = {};
        this.statementIdx = 0;
        this.showCancelButton = true;
        this.effects = [PolicyEffectType.ALLOW, PolicyEffectType.DENY];
        this.selectedActions = undefined;
        this.loadableServices$ = this.store.pipe(select(selectStatementServices));
        this.services$ = this.loadableServices$.pipe(filter(function (loadable) { return loadable && loadable.data; }), map(function (loaded) { return loaded.data; }));
        this.loadableServices$
            .pipe(filter(function (services) { return services === undefined; }))
            .subscribe(function () { return _this.store.dispatch(new LoadingPolicyStatementServicesAction()); });
    }
    PolicyStatementCardComponent.prototype.ngOnDestroy = function () {
        if (this.resourceActionSubscription !== undefined) {
            this.resourceActionSubscription.unsubscribe();
        }
    };
    PolicyStatementCardComponent.prototype.removeStatement = function () {
        this.store.dispatch(new RemoveStatementAction({ statementIdx: this.statementIdx }));
    };
    Object.defineProperty(PolicyStatementCardComponent.prototype, "resources$", {
        get: function () {
            if (!this.statement.service) {
                return undefined;
            }
            return this.store.pipe(select(selectStatementResources(this.statement.service.id)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyStatementCardComponent.prototype, "loadableResourceActions$", {
        get: function () {
            if (!this.statement.service) {
                return undefined;
            }
            return this.store.pipe(select(selectLoadableResourceActions(this.statement.service.id)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyStatementCardComponent.prototype, "actions$", {
        get: function () {
            var service = this.statement.service;
            var resource = this.statement.resource;
            if (service === undefined || resource === undefined) {
                return undefined;
            }
            return this.store.pipe(select(selectStatementActions(service.id, resource.id)));
        },
        enumerable: true,
        configurable: true
    });
    PolicyStatementCardComponent.prototype.selectEffect = function (effect) {
        var statementIdx = this.statementIdx;
        this.store.dispatch(new SelectEffectAction({ statementIdx: statementIdx, effect: effect }));
    };
    PolicyStatementCardComponent.prototype.selectService = function (service) {
        var statementIdx = this.statementIdx;
        this.store.dispatch(new SelectServiceAction({ statementIdx: statementIdx, service: service }));
        this.loadResourceActionsIfNecessary(service);
    };
    PolicyStatementCardComponent.prototype.selectResource = function (resource) {
        var statementIdx = this.statementIdx;
        this.store.dispatch(new SelectResourceAction({ statementIdx: statementIdx, resource: resource }));
    };
    PolicyStatementCardComponent.prototype.onSelectAction = function (actions) {
        var statementIdx = this.statementIdx;
        this.selectedActions = actions;
        this.store.dispatch(new SelectActionActions({ statementIdx: statementIdx, actions: actions }));
    };
    PolicyStatementCardComponent.prototype.trackByStatementIdx = function (idx) {
        return "statement" + idx;
    };
    PolicyStatementCardComponent.prototype.loadResourceActionsIfNecessary = function (service) {
        var _this = this;
        if (!this.resources$) {
            this.store.dispatch(new LoadingPolicyStatementResourceActionsAction({ serviceId: service.id }));
        }
        this.resourceActionSubscription = this.store
            .pipe(select(selectResourceActionsNeedLoading(service.id)), filter(function (needLoading) { return needLoading; }))
            .subscribe(function (needLoading) {
            _this.store.dispatch(new LoadingPolicyStatementResourceActionsAction({ serviceId: service.id }));
        });
    };
    PolicyStatementCardComponent.prototype.ngOnInit = function () { };
    return PolicyStatementCardComponent;
}());
export { PolicyStatementCardComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policy-statement-card/policy-statement-card.component.ts.pre-build-optimizer.js